<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click.prevent="getRighe()"> Contabilità </a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">{{ cfg.titolo }}</span>
				</h4>
			</div>
			<div class="d-lg-block my-lg-auto ms-lg-auto text-center">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2" style="text-align: left;" v-if="puo('CREATE')" v-on:click.prevent="nuovaRiga()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">{{ cfg.nuovo }}</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>
				</div>
			</div>
		</div>

		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill">
					<li class="nav-item me-1">
						<a href="#" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded active" @click.prevent>
							<div class="d-flex align-items-center mx-lg-1"><i :class="cfg.icona"></i><span class="ms-1">{{ cfg.titolo }}</span></div>
						</a>
					</li>
				</ul>
				<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
					<li class="nav-item dropdown ms-lg-1">
						<div class="btn-group">
							<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
								<i class="ph-gear me-1"></i><span style="font-size:0.8rem;"><Translate :path="'dizionario.base.AZIONI_MULTIPLE'"></Translate></span>
							</a>
							<div class="dropdown-menu dropdown-menu-end">
								<div class="dropdown-submenu dropdown-submenu-start" v-if="puo('EXPORT')">
									<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
									<div class="dropdown-menu">
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')"><i class="far fa-file-export fa-fw me-2"></i>Pagina corrente</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')"><i class="far fa-file-export fa-fw me-2"></i>Righe selezionate</a>
										<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')"><i class="far fa-file-export fa-fw me-2"></i>Tutte le righe</a>
									</div>
								</div>
								<a href="#" class="dropdown-item" v-if="puoFatturare" @click.prevent="apriGeneraFattura(selezionate())">
									<i class="far fa-file-invoice fa-fw me-2 text-primary"></i><span class="text-muted me-1">|</span>Genera fattura {{ cfg.fattura }}
								</a>
								<a href="#" class="dropdown-item" v-if="puo('CREATE')" @click.prevent="apriAssocia(selezionate())">
									<i class="far fa-link fa-fw me-2 text-primary"></i><span class="text-muted me-1">|</span>Associa a una fattura esistente
								</a>
								<a href="#" class="dropdown-item" v-if="incassi && puo('CREATE')" @click.prevent="apriIncasso(selezionate())">
									<i class="far fa-money-bill fa-fw me-2 text-success"></i><span class="text-muted me-1">|</span>Incassa selezionati
								</a>
								<a href="#" class="dropdown-item" v-if="$root.isGod && !incassi" @click.prevent="generaDaBudget()">
									<i class="far fa-magic fa-fw me-2 text-warning"></i><span class="text-muted me-1">|</span>Genera costi e incassi mancanti dal budget
								</a>
								<div class="dropdown-divider"></div>
								<a href="#" class="dropdown-item" v-if="puo('DELETE')" @click.prevent="elimina(selezionate().filter(r => !r.ORIGINE_TIPO))">
									<i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.ELIMINA_SELEZIONATI'"></Translate>
								</a>
								<a href="#" class="dropdown-item" v-if="$root.isGod && arrayRighe.some(r => r.SELEZIONATO == 1 && r.FLG_ELIMINATO == 1)" @click.prevent="ripristina(arrayRighe.filter(r => r.SELEZIONATO == 1 && r.FLG_ELIMINATO == 1 && !r.ORIGINE_TIPO))">
									<i class="fad fa-redo fa-fw me-2 text-success"></i><span class="text-muted me-1">|</span>Ripristina selezionati
								</a>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- /page header -->

	<div class="content content-1 table-cms-wrapper">

		<div class="row g-2 mb-2">
			<div class="col-6 col-xl-3" v-for="k in kpi" :key="k.label">
				<KpiCard :label="k.label" :icona="k.icona" :tema="k.tema" :indicatore="{ valore: k.valore, unita: 'EUR' }" :nota="k.nota" />
			</div>
		</div>

		<div class="card shadow mb-xs-3 mb-lg-0">
			<div class="card-body pb-0">
				<div class="alert alert-2 alert-secondary border-0">
					<div class="row g-2 align-items-center">
						<div class="col-6 col-md-1">
							<select class="form-select form-select-sm" v-model="anno" @change="getRighe()">
								<option :value="0">Tutti</option>
								<option v-for="a in anni" :key="a" :value="a">{{ a }}</option>
							</select>
						</div>
						<div class="col-6 col-md-2">
							<select class="form-select form-select-sm" v-model="stato">
								<option v-for="s in stati" :key="s.valore" :value="s.valore">{{ s.label }}</option>
							</select>
						</div>
						<div class="col-12 col-md-3">
							<SelectIntestatario v-model:pg="filtroPg" v-model:pf="filtroPf" :api-aziende="'shared-s2/aziende?TIPO=' + cfg.tipoAziende" :placeholder="'Tutti'" @change="getRighe()"></SelectIntestatario>
						</div>
						<div class="col-12 col-md-3">
							<SelectCommessa v-model:tipo="filtroCommessaTipo" v-model:id="filtroCommessaId" :placeholder="'Tutte le commesse'" @change="getRighe()"></SelectCommessa>
						</div>
						<div class="col-11 col-md-2">
							<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Cerca descrizione" v-model="search.DESCRIZIONE.VALUE" />
						</div>
						<div class="col-12" v-if="filtroOrigine">
							<span class="badge bg-primary p-2">Solo da {{ filtrate.length ? etichettaOrigine(filtrate[0]) : filtroOrigine.ORIGINE_TIPO + ' ' + filtroOrigine.ORIGINE_ID }}<a href="#" class="text-white ms-2" title="Togli il filtro" @click.prevent="togliFiltroOrigine()"><i class="ph-x"></i></a></span>
						</div>
						<div class="col-1 col-xl-auto ps-0" v-if="$root.isGod">
							<a :href="'#collapse-' + modulo" class="btn btn-flat-info btn-sm w-100 collapsed" data-bs-toggle="collapse" @click.prevent="filters.resizeGrid('collapse-' + modulo, 'tableFixHead', 'box-card')" role="button" aria-expanded="false">S</a>
						</div>
					</div>
					<div class="collapse" :id="'collapse-' + modulo" v-if="$root.isGod">
						<div class="row">
							<div class="col-12 col-md-2 mt-1">
								<select class="form-select form-select-sm" v-model="eliminati" @change="getRighe()">
									<option value="0">Non eliminati</option>
									<option value="2">Tutti</option>
									<option value="1">Eliminati</option>
								</select>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card-body box-card mt-0 mb-0" id="box-card">
				<div class="div_table_resp tableFixHead" id="tableFixHead">
					<table class="table table-bordered table-hover table-striped text-nowrap align-middle">
						<thead class="sticky-top">
							<tr class="bg-secondary text-white">
								<th class="table-head-sm text-center" style="width: 2%;"><input :id="'chkAll' + modulo" type="checkbox" v-on:click="filters.selectAll('chkAll' + modulo, paginatedList.arr)"></th>
								<th class="table-head-sm text-center" style="width: 7%;">Data</th>
								<th class="table-head-sm" style="width: 15%;">Intestatario</th>
								<th class="table-head-sm">Descrizione</th>
								<th class="table-head-sm" style="width: 14%;">Commessa</th>
								<th class="table-head-sm text-end" style="width: 9%;">Importo</th>
								<th class="table-head-sm text-end" style="width: 9%;">Associato</th>
								<th class="table-head-sm text-center" style="width: 7%;">Da associare</th>
								<th class="table-head-sm" style="width: 12%;" v-if="incassi">Incasso</th>
								<th class="table-head-sm text-center" style="width: 5%;"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="r in paginatedList.arr" :key="r[cfg.chiave]" :class="{ 'table-danger text-muted': r.FLG_ELIMINATO == 1 }">
								<td class="td-class text-center"><input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="r.SELEZIONATO"></td>
								<td class="td-class text-center fs-sm">{{ r.DATA_COMPETENZA_IT }}</td>
								<td class="td-class fs-sm" style="max-width: 0;"><div class="d-flex align-items-center" v-if="r.INTESTATARIO"><TestoEspandibile :testo="r.INTESTATARIO" icona="ph-user" /><span class="badge bg-light text-muted ms-1 flex-shrink-0">{{ r.TIPO_INTESTATARIO }}</span></div></td>
								<td class="td-class fs-sm" style="max-width: 0;">
									<div class="d-flex align-items-center">
										<TestoEspandibile :testo="r.DESCRIZIONE" />
										<span v-if="r.FLG_ELIMINATO == 1" class="badge bg-danger ms-1 flex-shrink-0">Eliminato</span>
									</div>
									<TestoEspandibile v-if="r.ORIGINE_TIPO" class="text-muted fs-xs" :testo="etichettaOrigine(r)" icona="ph-link" />
								</td>
								<td class="td-class fs-sm" style="max-width: 0;"><TestoEspandibile v-if="r.COMMESSA_TIPO" :testo="etichettaCommessa(r)" icona="ph-briefcase" /><span v-else class="text-muted">Generale</span></td>
								<td class="td-class fs-sm text-end fw-semibold">&euro; {{ filters.formattaImporto(r.IMPORTO) }}</td>
								<td class="td-class fs-sm text-end">
									<a href="#" v-if="r.NUM_FATTURE > 0" @click.prevent="apriAssociazioni(r)" title="Fatture associate">&euro; {{ filters.formattaImporto(r.ASSOCIATO) }} <small class="text-muted">({{ r.NUM_FATTURE }})</small></a>
									<span v-else class="text-muted">&euro; 0,00</span>
								</td>
								<td class="td-class text-center"><span class="badge" :class="r.RESIDUO > 0 ? 'bg-warning text-dark' : 'bg-success'" :title="'Residuo € ' + filters.formattaImporto(r.RESIDUO)">{{ percDaAssociare(r) }}%</span></td>
								<td class="td-class fs-sm" v-if="incassi">
									<a href="#" v-if="r.INCASSATO != 1 && r.FLG_ELIMINATO != 1 && puo('CREATE')" class="badge bg-warning text-dark" title="Segna come incassato" @click.prevent="apriIncasso([r])">Da incassare</a>
									<span v-else class="badge" :class="r.INCASSATO == 1 ? 'bg-success' : 'bg-warning text-dark'">{{ r.INCASSATO == 1 ? 'Incassato' : 'Da incassare' }}</span>
									<small class="text-muted ms-1" v-if="r.INCASSATO == 1">{{ r.DATA_INCASSO_IT }} · {{ r.CONTO }}</small>
								</td>
								<td class="td-class text-center">
									<div class="dropdown">
										<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false"><i class="ph-list"></i></a>
										<div class="dropdown-menu dropdown-menu-end">
											<template v-if="r.FLG_ELIMINATO != 1">
												<a href="#" class="dropdown-item" v-if="!r.ORIGINE_TIPO && puo('UPDATE')" @click.prevent="modificaRiga(r)"><i class="fad fa-pencil fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica</a>
												<a href="#" class="dropdown-item" v-if="r.NUM_FATTURE > 0" @click.prevent="apriAssociazioni(r)"><i class="fad fa-file-invoice fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Fatture associate</a>
												<a href="#" class="dropdown-item" v-if="r.RESIDUO > 0 && puo('CREATE')" @click.prevent="apriAssocia([r])"><i class="fad fa-link fa-lg fa-fw me-2 text-primary"></i><span class="text-muted me-1">|</span>Associa a fattura</a>
												<a href="#" class="dropdown-item" v-if="r.RESIDUO > 0 && puoFatturare" @click.prevent="apriGeneraFattura([r])"><i class="fad fa-file-plus fa-lg fa-fw me-2 text-primary"></i><span class="text-muted me-1">|</span>Genera fattura</a>
												<template v-if="incassi">
													<a href="#" class="dropdown-item" v-if="r.INCASSATO != 1 && puo('CREATE')" @click.prevent="apriIncasso([r])"><i class="fad fa-money-bill fa-lg fa-fw me-2 text-success"></i><span class="text-muted me-1">|</span>Segna come incassato</a>
													<a href="#" class="dropdown-item" v-if="r.INCASSATO == 1 && $root.hasFunzionalita('PRIMA_NOTA_DELETE')" @click.prevent="annullaIncasso(r)"><i class="fad fa-undo fa-lg fa-fw me-2 text-warning"></i><span class="text-muted me-1">|</span>Annulla incasso</a>
												</template>
												<a href="#" class="dropdown-item" v-if="!r.ORIGINE_TIPO && puo('DELETE')" @click.prevent="elimina([r])"><i class="fad fa-trash fa-lg fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina</a>
											</template>
											<a href="#" class="dropdown-item text-success" v-if="$root.isGod && r.FLG_ELIMINATO == 1 && !r.ORIGINE_TIPO" @click.prevent="ripristina([r])"><i class="fad fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate></a>
										</div>
									</div>
								</td>
							</tr>
							<tr v-if="paginatedList.count == 0">
								<td :colspan="incassi ? 10 : 9" class="text-center text-muted py-4">
									<i :class="cfg.icona" class="d-block mb-2" style="font-size: 2.5rem;"></i>
									Nessun {{ cfg.riga }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="row page-bottom">
					<div class="col-12 col-md-5 d-none d-sm-block">
						<div style="position: relative; top: 10px;">
							<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">{{ cfg.titolo.toUpperCase() }}: {{ paginatedList.count }}</span>
						</div>
					</div>
					<div class="col-9 col-md-6">
						<div class="float-end pag-mobile">
							<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
						</div>
					</div>
					<div class="col-3 col-md-1">
						<select class="form-select form-select-sm wmin-100 mt-2 float-end" v-model="search.PAGINATION.PAGE_SIZE">
							<option value="25">25</option>
							<option value="50">50</option>
							<option value="100">100</option>
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE RIGA A MANO -->
	<div class="modal fade" :id="'popUpRiga' + rs" role="dialog" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">{{ riga[cfg.chiave] > 0 ? 'Modifica ' + cfg.riga : cfg.nuovo }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div v-if="riga.ASSOCIATO > 0 || riga.INCASSATO == 1" class="alert alert-info p-2 fs-sm"><i class="ph-info me-1"></i>{{ riga.INCASSATO == 1 ? 'Già incassato' : 'Già in fattura' }}: importo e intestatario non si cambiano più.</div>
					<div class="row">
						<div class="col-12 mb-2">
							<label class="form-label">Intestatario *</label>
							<SelectIntestatario v-model:pg="riga.FK_ID_PERSONA_GIURIDICA" v-model:pf="riga.FK_ID_PERSONA_FISICA" :api-aziende="'shared-s2/aziende?TIPO=' + cfg.tipoAziende" :disabled="riga.ASSOCIATO > 0 || riga.INCASSATO == 1" :placeholder="'Seleziona'"></SelectIntestatario>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Descrizione</label>
							<input type="text" class="form-control form-control-sm" v-model="riga.DESCRIZIONE" autocomplete="off" :placeholder="incassi ? 'Es. provvigione fornitore' : 'Es. affitto ufficio novembre'">
						</div>
						<div class="col-6 mb-2">
							<label class="form-label">Data *</label>
							<Datepicker v-model="riga.DATA_COMPETENZA" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" />
						</div>
						<div class="col-6 mb-2">
							<label class="form-label">Importo con IVA *</label>
							<input type="text" inputmode="decimal" class="form-control form-control-sm text-end" placeholder="0,00" v-model="riga.IMPORTO" @blur="normalizza(riga, 'IMPORTO')" :disabled="riga.ASSOCIATO > 0 || riga.INCASSATO == 1">
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Codice IVA <small class="text-muted">(proposto quando generi la fattura)</small></label>
							<select class="form-select form-select-sm" v-model="riga.FK_ID_IVA">
								<option :value="0">— Nessuno —</option>
								<option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}</option>
							</select>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Commessa</label>
							<SelectCommessa v-model:tipo="riga.COMMESSA_TIPO" v-model:id="riga.COMMESSA_ID" :placeholder="'Generale (nessuna commessa)'"></SelectCommessa>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Note</label>
							<input type="text" class="form-control form-control-sm" v-model="riga.NOTE" autocomplete="off">
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="ph-x me-1"></i>Annulla</button>
					<template v-if="puo(riga[cfg.chiave] > 0 ? 'UPDATE' : 'CREATE')">
						<button type="button" class="btn btn-sm btn-secondary" @click="salvaRiga(false)"><i class="ph-check me-1"></i>Salva e chiudi</button>
						<button type="button" class="btn btn-sm btn-primary" v-if="!(riga[cfg.chiave] > 0)" @click="salvaRiga(true)"><i class="ph-check me-1"></i>Salva e continua</button>
					</template>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE GENERA FATTURA -->
	<div class="modal fade" :id="'popUpGenera' + rs" role="dialog" tabindex="-1">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title"><i class="far fa-file-invoice fa-fw me-1"></i> Genera fattura {{ cfg.fattura }} · {{ genera.INTESTATARIO }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<table class="table table-sm mb-3">
						<thead><tr><th>Descrizione</th><th>Commessa</th><th class="text-end" style="width:18%;">Da fatturare</th></tr></thead>
						<tbody>
							<tr v-for="r in genera.righe" :key="r[cfg.chiave]">
								<td class="fs-sm">{{ r.DESCRIZIONE }}</td>
								<td class="fs-sm">{{ r.COMMESSA_TIPO ? etichettaCommessa(r) : 'Generale' }}</td>
								<td class="fs-sm text-end">&euro; {{ filters.formattaImporto(r.RESIDUO) }}</td>
							</tr>
						</tbody>
					</table>
					<div class="row">
						<div class="col-6 col-md-3 mb-2">
							<label class="form-label">Numero *</label>
							<input type="text" class="form-control form-control-sm" v-model="genera.NUMERO" autocomplete="off">
						</div>
						<div class="col-6 col-md-3 mb-2">
							<label class="form-label">Data *</label>
							<Datepicker v-model="genera.DATA_FATTURA" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" />
						</div>
						<div class="col-12 col-md-6 mb-2">
							<label class="form-label">Descrizione</label>
							<input type="text" class="form-control form-control-sm" v-model="genera.DESCRIZIONE" autocomplete="off">
						</div>
						<div class="col-12 col-md-6 mb-2">
							<label class="form-label">Codice IVA</label>
							<select class="form-select form-select-sm" v-model="genera.FK_ID_IVA">
								<option :value="0">— Nessuna —</option>
								<option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}</option>
							</select>
						</div>
						<div class="col-4 col-md-2 mb-2">
							<label class="form-label">Netto</label>
							<input type="text" class="form-control form-control-sm text-end" :value="filters.formattaImporto(nettoGenera)" disabled>
						</div>
						<div class="col-4 col-md-2 mb-2">
							<label class="form-label">IVA</label>
							<input type="text" class="form-control form-control-sm text-end" :value="filters.formattaImporto(ivaGenera)" disabled>
						</div>
						<div class="col-4 col-md-2 mb-2">
							<label class="form-label">Totale</label>
							<input type="text" class="form-control form-control-sm text-end fw-semibold" :value="filters.formattaImporto(totaleGenera)" disabled>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Note</label>
							<input type="text" class="form-control form-control-sm" v-model="genera.NOTE" autocomplete="off">
						</div>
					</div>
					<p class="fs-sm text-muted mb-0">Il totale è la somma dei residui: netto e IVA si ricavano scorporando il codice IVA scelto.</p>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="ph-x me-1"></i>Annulla</button>
					<button type="button" class="btn btn-sm btn-primary" @click="generaFattura()"><i class="ph-check me-1"></i>Crea fattura</button>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE ASSOCIA A FATTURA ESISTENTE -->
	<div class="modal fade" :id="'popUpAssocia' + rs" role="dialog" tabindex="-1">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title"><i class="far fa-link fa-fw me-1"></i> Associa a una fattura {{ cfg.fattura }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<label class="form-label">Fattura *</label>
					<select class="form-select form-select-sm mb-3" v-model="associa.FK_ID_FATTURA">
						<option :value="0">Seleziona una fattura con residuo</option>
						<option v-for="f in associa.fatture" :key="f.ID_FATTURA" :value="f.ID_FATTURA">n. {{ f.NUMERO }} del {{ f.DATA_FATTURA_IT }} · totale € {{ filters.formattaImporto(f.IMPORTO_TOTALE) }} · da associare € {{ filters.formattaImporto(f.RESIDUO) }}</option>
					</select>
					<table class="table table-sm mb-2">
						<thead><tr><th>Descrizione</th><th class="text-end" style="width:18%;">Residuo</th><th class="text-end" style="width:22%;">Su questa fattura</th></tr></thead>
						<tbody>
							<tr v-for="r in associa.righe" :key="r[cfg.chiave]">
								<td class="fs-sm">{{ r.DESCRIZIONE }}</td>
								<td class="fs-sm text-end">&euro; {{ filters.formattaImporto(r.RESIDUO) }}</td>
								<td><input type="text" inputmode="decimal" class="form-control form-control-sm text-end" v-model="r.IMPORTO_ASSOCIA" @blur="normalizza(r, 'IMPORTO_ASSOCIA')"></td>
							</tr>
						</tbody>
					</table>
					<div class="d-flex fs-sm">
						<span>Totale da associare: <strong>&euro; {{ filters.formattaImporto(totaleAssocia) }}</strong></span>
						<span class="ms-auto" v-if="associa.FK_ID_FATTURA > 0" :class="totaleAssocia > residuoFatturaScelta + 0.005 ? 'text-danger' : 'text-muted'">Residuo della fattura: &euro; {{ filters.formattaImporto(residuoFatturaScelta) }}</span>
					</div>
				</div>
				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" data-bs-dismiss="modal"><i class="ph-x me-1"></i>Annulla</button>
					<button type="button" class="btn btn-sm btn-primary" @click="salvaAssocia()"><i class="ph-check me-1"></i>Associa</button>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE FATTURE ASSOCIATE A UNA RIGA -->
	<div class="modal fade" :id="'popUpAssociazioni' + rs" role="dialog" tabindex="-1">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title"><i class="far fa-file-invoice fa-fw me-1"></i> Fatture associate · {{ rigaAssociazioni.DESCRIZIONE }}</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<table class="table table-sm mb-0">
						<thead><tr><th>Fattura</th><th class="text-end">Totale fattura</th><th class="text-end">Associato</th><th>Note</th><th class="text-center" style="width:8%;"></th></tr></thead>
						<tbody>
							<tr v-for="a in associazioni" :key="a.ID_ASSOCIAZIONE">
								<td class="fs-sm"><a href="#" @click.prevent="apriFattura(a)">n. {{ a.NUMERO }}</a> <small class="text-muted">del {{ a.DATA_FATTURA_IT }}</small></td>
								<td class="fs-sm text-end">&euro; {{ filters.formattaImporto(a.IMPORTO_TOTALE) }}</td>
								<td class="fs-sm text-end fw-semibold">&euro; {{ filters.formattaImporto(a.IMPORTO) }}</td>
								<td class="fs-sm">{{ a.NOTE }}</td>
								<td class="text-center"><a href="#" v-if="puo('DELETE')" class="text-danger" title="Togli l'associazione" @click.prevent="dissocia(a)"><i class="ph-trash"></i></a></td>
							</tr>
							<tr v-if="associazioni.length == 0"><td colspan="5" class="text-muted fs-sm">Nessuna fattura associata</td></tr>
						</tbody>
					</table>
				</div>
				<div class="modal-footer bg-light">
					<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">CHIUDI</button>
				</div>
			</div>
		</div>
	</div>

	<!-- MODALE INCASSO -->
	<div class="modal fade" :id="'popUpIncasso' + rs" role="dialog" tabindex="-1" v-if="incassi">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">Registra incasso</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<p class="fs-sm text-muted mb-3">In Prima Nota verrà registrata un'entrata di <strong>&euro; {{ filters.formattaImporto(incasso.IMPORTO) }}</strong>{{ incasso.INTESTATARIO ? ' da ' + incasso.INTESTATARIO : '' }}.</p>
					<div class="row">
						<div class="col-6 mb-2">
							<label class="form-label">Data incasso *</label>
							<Datepicker v-model="incasso.DATA_MOVIMENTO" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" />
						</div>
						<div class="col-6 mb-2">
							<label class="form-label">Pagamento *</label>
							<SelectConto v-model="incasso.FK_ID_CONTO"></SelectConto>
						</div>
						<div class="col-12 mb-2">
							<label class="form-label">Descrizione</label>
							<input type="text" class="form-control form-control-sm" v-model="incasso.DESCRIZIONE" autocomplete="off">
						</div>
					</div>
				</div>
				<div class="modal-footer bg-light">
					<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">CHIUDI</button>
					<button type="button" class="btn btn-success btn-sm" @click="incassa()">REGISTRA INCASSO</button>
				</div>
			</div>
		</div>
	</div>

	<PopUpEsportazione :id="'popUpEsportazione' + rs" @esporta="esportaDati" />

</template>

<script>

import Pagine from '@/components/utils/Pagine.vue'
import SelectIntestatario from '@/components/common/SelectIntestatario.vue'
import SelectConto from '@/components/common/SelectConto.vue'
import SelectCommessa from '@/components/common/SelectCommessa.vue'
import KpiCard from '@/components/dashboard/KpiCard.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'
import TestoEspandibile from '@/components/common/TestoEspandibile.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

// Costi e incassi hanno la stessa forma (pacchetto contabilità, API shared/costi|incassi): cambia solo questo
const CONFIG = {
	costi: { titolo: 'Costi', nuovo: 'Nuovo costo', riga: 'costo', righe: 'costi', icona: 'ph-arrow-circle-up-right', chiave: 'ID_COSTO', fk: 'FK_ID_COSTO', permesso: 'COSTI', tipoFattura: 1, fattura: "d'acquisto", tipoAziende: 2 },
	incassi: { titolo: 'Incassi', nuovo: 'Nuovo incasso', riga: 'incasso', righe: 'incassi', icona: 'ph-arrow-circle-down-left', chiave: 'ID_INCASSO', fk: 'FK_ID_INCASSO', permesso: 'INCASSI', tipoFattura: 2, fattura: 'di vendita', tipoAziende: 1 },
};

const num = (v) => parseInt(String(v ?? '').replace(/_/g, '')) || 0;

export default {
	name: "GrigliaContabile",

	components: { Pagine, SelectIntestatario, SelectConto, SelectCommessa, KpiCard, PopUpEsportazione, TestoEspandibile, Datepicker },

	props: {
		modulo: { type: String, required: true },
	},

	data: function () {
		return {
			filters: global.filters,
			rs: utils.generateRandomString(30),
			anno: new Date().getFullYear(),
			stato: '',
			filtroPg: 0,
			filtroPf: 0,
			filtroCommessaTipo: '',
			filtroCommessaId: 0,
			filtroOrigine: null,
			eliminati: 0,
			esportazioneTipo: '',
			arrayRighe: [],
			riga: {},
			genera: { righe: [] },
			associa: { righe: [], fatture: [], FK_ID_FATTURA: 0 },
			rigaAssociazioni: {},
			associazioni: [],
			incasso: {},
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
			},
		}
	},

	computed: {
		cfg() {
			return CONFIG[this.modulo];
		},
		incassi() {
			return this.modulo == 'incassi';
		},
		puoFatturare() {
			return this.puo('CREATE') && this.$root.hasFunzionalita('FATTURAZIONE_CREATE');
		},
		anni() {
			const oggi = new Date().getFullYear();
			return Array.from({ length: 6 }, (x, i) => oggi + 1 - i);
		},
		stati() {
			const stati = [{ valore: '', label: 'Tutti' }, { valore: 'DA_FATTURARE', label: 'Da fatturare' }, { valore: 'FATTURATI', label: 'Fatturati' }];
			return this.incassi ? stati.concat([{ valore: 'DA_INCASSARE', label: 'Da incassare' }, { valore: 'INCASSATI', label: 'Incassati' }]) : stati;
		},
		filtrate() {
			const s = this.stato;
			const o = this.filtroOrigine;
			return this.arrayRighe.filter(r => (!o || (r.ORIGINE_TIPO == o.ORIGINE_TIPO && r.ORIGINE_ID == o.ORIGINE_ID)) && (s == ''
				|| (s == 'DA_FATTURARE' && r.RESIDUO > 0) || (s == 'FATTURATI' && r.RESIDUO <= 0)
				|| (s == 'DA_INCASSARE' && r.INCASSATO != 1) || (s == 'INCASSATI' && r.INCASSATO == 1)));
		},
		paginatedList() {
			return utils.inGrid(this.filtrate, this.search);
		},
		kpi() {
			const attive = this.arrayRighe.filter(r => r.FLG_ELIMINATO != 1);
			const gruppo = (f, campo = 'IMPORTO') => { const a = attive.filter(f); return { tot: utils.array.sumByField(a, campo), n: a.length }; };
			const tutte = gruppo(() => true), daFatturare = gruppo(r => r.RESIDUO > 0, 'RESIDUO');
			const totale = { label: this.incassi ? 'Totale atteso' : 'Totale costi', valore: tutte.tot, tema: 'blue', icona: 'ph-receipt', nota: tutte.n + ' ' + this.cfg.righe };
			const daFatt = { label: 'Da fatturare', valore: daFatturare.tot, tema: 'red', icona: 'ph-warning-circle', nota: daFatturare.n + ' ' + this.cfg.righe + ' senza fattura completa' };
			if (this.incassi) {
				const aperti = gruppo(r => r.INCASSATO != 1), incassati = gruppo(r => r.INCASSATO == 1);
				return [
					totale,
					{ label: 'Da incassare', valore: aperti.tot, tema: 'purple', icona: 'ph-hourglass', nota: aperti.n + ' incassi aperti' },
					{ label: 'Incassati', valore: incassati.tot, tema: 'green', icona: 'ph-check-circle', nota: incassati.n + ' registrati in Prima Nota' },
					daFatt,
				];
			}
			const fatturati = gruppo(() => true, 'ASSOCIATO'), generali = gruppo(r => !r.COMMESSA_TIPO);
			return [
				totale,
				daFatt,
				{ label: 'Fatturati', valore: fatturati.tot, tema: 'green', icona: 'ph-check-circle', nota: "Associati a fatture d'acquisto" },
				{ label: 'Costi generali', valore: generali.tot, tema: 'purple', icona: 'ph-buildings', nota: generali.n + ' senza commessa' },
			];
		},
		totaleGenera() {
			return Math.round(this.genera.righe.reduce((tot, r) => tot + parseFloat(r.RESIDUO), 0) * 100) / 100;
		},
		// Il totale è IVA compresa: si scorpora con l'aliquota del codice scelto
		nettoGenera() {
			const aliquota = this.filters.ivaSuImponibile(100, this.genera.FK_ID_IVA) / 100;
			return Math.round(this.totaleGenera / (1 + aliquota) * 100) / 100;
		},
		ivaGenera() {
			return Math.round((this.totaleGenera - this.nettoGenera) * 100) / 100;
		},
		totaleAssocia() {
			return Math.round(this.associa.righe.reduce((tot, r) => tot + this.filters.parseImporto(r.IMPORTO_ASSOCIA), 0) * 100) / 100;
		},
		residuoFatturaScelta() {
			const f = this.associa.fatture.find(f => f.ID_FATTURA == this.associa.FK_ID_FATTURA);
			return f ? parseFloat(f.RESIDUO) : 0;
		},
	},

	methods: {
		puo(verbo) {
			return this.$root.hasFunzionalita(this.cfg.permesso + '_' + verbo);
		},

		api(operazione) {
			return 'shared/' + this.modulo + '/' + operazione;
		},

		getRighe(dopo) {
			const commessa = num(this.filtroCommessaId);
			const params = { ANNO: this.anno, FK_ID_PERSONA_GIURIDICA: this.filtroPg || 0, FK_ID_PERSONA_FISICA: this.filtroPf || 0, COMMESSA_TIPO: commessa > 0 ? this.filtroCommessaTipo : '', COMMESSA_ID: commessa, ELIMINATI: this.eliminati };
			utils.ajax(this.api('lista'), params, (response) => {
				this.arrayRighe = response.data;
				if (dopo) dopo();
			}, true, 0, 'GET');
		},

		selezionate() {
			return this.arrayRighe.filter(r => r.SELEZIONATO == 1 && r.FLG_ELIMINATO != 1);
		},

		etichettaOrigine(r) {
			return r.ORIGINE_LABEL || (r.ORIGINE_TIPO + ' ' + r.ORIGINE_ID);
		},

		etichettaCommessa(r) {
			return r.COMMESSA_LABEL || (r.COMMESSA_TIPO + ' ' + r.COMMESSA_ID);
		},

		percDaAssociare(r) {
			return r.IMPORTO > 0 ? Math.round(r.RESIDUO / r.IMPORTO * 1000) / 10 : 0;
		},

		// Fatture e incassi raggruppano righe dello stesso intestatario: lo controlla anche il server
		stessoIntestatario(righe) {
			if (new Set(righe.map(r => r.FK_ID_PERSONA_GIURIDICA + '-' + r.FK_ID_PERSONA_FISICA)).size <= 1) return true;
			utils.alert.warning('Le righe selezionate devono avere lo stesso intestatario.');
			return false;
		},

		rigaVuota() {
			return { [this.cfg.chiave]: 0, FK_ID_PERSONA_GIURIDICA: this.filtroPg || 0, FK_ID_PERSONA_FISICA: this.filtroPf || 0, DESCRIZIONE: '', DATA_COMPETENZA: new Date(), IMPORTO: '', FK_ID_IVA: 0, NOTE: '', COMMESSA_TIPO: this.filtroCommessaTipo, COMMESSA_ID: num(this.filtroCommessaId), ASSOCIATO: 0, INCASSATO: 0 };
		},

		nuovaRiga() {
			this.riga = this.rigaVuota();
			this.filters.openPopUp('popUpRiga' + this.rs);
		},

		modificaRiga(r) {
			this.riga = utils.clone(r);
			this.riga.DATA_COMPETENZA = new Date(r.DATA_COMPETENZA);
			this.riga.FK_ID_IVA = parseInt(r.FK_ID_IVA) || 0;
			this.normalizza(this.riga, 'IMPORTO');
			this.filters.openPopUp('popUpRiga' + this.rs);
		},

		salvaRiga(continua = false) {
			const r = this.riga;
			const params = { [this.cfg.chiave]: r[this.cfg.chiave], FK_ID_PERSONA_GIURIDICA: num(r.FK_ID_PERSONA_GIURIDICA), FK_ID_PERSONA_FISICA: num(r.FK_ID_PERSONA_FISICA), DESCRIZIONE: r.DESCRIZIONE, DATA_COMPETENZA: this.filters.formatDateOnly(r.DATA_COMPETENZA), IMPORTO: this.filters.parseImporto(r.IMPORTO), FK_ID_IVA: r.FK_ID_IVA, NOTE: r.NOTE, COMMESSA_TIPO: r.COMMESSA_TIPO, COMMESSA_ID: num(r.COMMESSA_ID) };
			const nuova = !(params[this.cfg.chiave] > 0);
			utils.ajax(this.api(nuova ? 'insert' : 'update'), params, (response) => {
				utils.alert.success(response.messaggio);
				if (continua) {
					this.riga = this.rigaVuota();
				} else {
					this.filters.closePopUp('popUpRiga' + this.rs);
				}
				this.getRighe();
			}, true, 0, nuova ? 'POST' : 'PUT');
		},

		elimina(righe) {
			if (righe.length == 0) { utils.alert.warning('Nessuna riga inserita a mano selezionata: quelle generate da un altro modulo si eliminano da lì.'); return; }
			utils.alert.confirm(righe.length == 1 ? 'Eliminare "' + righe[0].DESCRIZIONE + '"?' : 'Eliminare ' + righe.length + ' ' + this.cfg.righe + '?', () => {
				utils.ajax(this.api('delete'), { IDS: righe.map(r => r[this.cfg.chiave]) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getRighe();
				}, true, 0, 'DELETE');
			}, this.$root);
		},

		ripristina(righe) {
			if (righe.length == 0) { utils.alert.warning('Nessuna riga inserita a mano selezionata.'); return; }
			utils.alert.confirm(righe.length == 1 ? 'Ripristinare "' + righe[0].DESCRIZIONE + '"?' : 'Ripristinare ' + righe.length + ' ' + this.cfg.righe + '?', () => {
				utils.ajax(this.api('ripristina'), { IDS: righe.map(r => r[this.cfg.chiave]) }, (response) => {
					utils.alert.success(response.messaggio);
					this.getRighe();
				}, true, 0, 'PUT');
			}, this.$root);
		},

		generaDaBudget() {
			utils.alert.confirm('Creare i costi e gli incassi che mancano, partendo dal budget di tutti i progetti? Quelli che esistono già non vengono toccati.', () => {
				utils.ajax('theb/contabilita/migra', {}, (response) => {
					utils.alert.success(response.messaggio);
					this.getRighe();
				}, true, 0, 'POST');
			}, this.$root);
		},

		apriGeneraFattura(righe) {
			righe = righe.filter(r => r.RESIDUO > 0);
			if (righe.length == 0) { utils.alert.warning('Nessuna riga con importo ancora da fatturare.'); return; }
			if (!this.stessoIntestatario(righe)) return;
			const iva = new Set(righe.map(r => parseInt(r.FK_ID_IVA) || 0));
			this.genera = { righe: righe, INTESTATARIO: righe[0].INTESTATARIO, NUMERO: '', DATA_FATTURA: new Date(), DESCRIZIONE: righe.length == 1 ? righe[0].DESCRIZIONE : '', FK_ID_IVA: iva.size == 1 ? [...iva][0] : 0, NOTE: '' };
			this.filters.openPopUp('popUpGenera' + this.rs);
		},

		generaFattura() {
			const g = this.genera;
			const params = { IDS: g.righe.map(r => r[this.cfg.chiave]), NUMERO: g.NUMERO, DATA_FATTURA: this.filters.formatDateOnly(g.DATA_FATTURA), DESCRIZIONE: g.DESCRIZIONE, NOTE: g.NOTE, FK_ID_IVA: g.FK_ID_IVA, IMPORTO_NETTO: this.nettoGenera, IMPORTO_IVA: this.ivaGenera };
			utils.ajax(this.api('genera-fattura'), params, (response) => {
				utils.alert.success(response.messaggio);
				this.filters.closePopUp('popUpGenera' + this.rs);
				this.getRighe();
			}, true, 0, 'POST');
		},

		apriAssocia(righe) {
			righe = righe.filter(r => r.RESIDUO > 0);
			if (righe.length == 0) { utils.alert.warning('Nessuna riga con importo ancora da fatturare.'); return; }
			if (!this.stessoIntestatario(righe)) return;
			this.associa = { righe: righe.map(r => ({ ...r, IMPORTO_ASSOCIA: this.filters.formattaImporto(r.RESIDUO) })), fatture: [], FK_ID_FATTURA: 0 };
			utils.ajax(this.api('fatture-aperte'), { IDS: righe.map(r => r[this.cfg.chiave]) }, (response) => {
				if (response.data.length == 0) {
					utils.alert.warning('Nessuna fattura ' + this.cfg.fattura + ' attiva con residuo per ' + righe[0].INTESTATARIO + ': puoi generarne una nuova.');
					return;
				}
				this.associa.fatture = response.data;
				if (response.data.length == 1) this.associa.FK_ID_FATTURA = response.data[0].ID_FATTURA;
				this.filters.openPopUp('popUpAssocia' + this.rs);
			}, true, 0, 'GET');
		},

		// Una richiesta per riga, in fila: il server ricontrolla i tetti a ogni associazione
		salvaAssocia() {
			if (!(this.associa.FK_ID_FATTURA > 0)) { utils.alert.warning('Scegli la fattura.'); return; }
			const righe = this.associa.righe.filter(r => this.filters.parseImporto(r.IMPORTO_ASSOCIA) > 0);
			const prossima = (i) => {
				if (i >= righe.length) {
					utils.alert.success('Associazione salvata');
					this.filters.closePopUp('popUpAssocia' + this.rs);
					this.getRighe();
					return;
				}
				const params = { [this.cfg.fk]: righe[i][this.cfg.chiave], FK_ID_FATTURA: this.associa.FK_ID_FATTURA, IMPORTO: this.filters.parseImporto(righe[i].IMPORTO_ASSOCIA) };
				utils.ajax(this.api('associazione'), params, () => prossima(i + 1), true, 0, 'POST');
			};
			prossima(0);
		},

		apriAssociazioni(r) {
			this.rigaAssociazioni = r;
			this.getAssociazioni();
			this.filters.openPopUp('popUpAssociazioni' + this.rs);
		},

		getAssociazioni() {
			utils.ajax(this.api('associazione'), { [this.cfg.chiave]: this.rigaAssociazioni[this.cfg.chiave] }, (response) => {
				this.associazioni = response.data;
			}, true, 0, 'GET');
		},

		dissocia(a) {
			utils.alert.confirm('Togliere l\'associazione con la fattura n. ' + a.NUMERO + '?', () => {
				utils.ajax(this.api('associazione'), { ID_ASSOCIAZIONE: a.ID_ASSOCIAZIONE }, (response) => {
					utils.alert.success(response.messaggio);
					this.getAssociazioni();
					this.getRighe();
				}, true, 0, 'DELETE');
			}, this.$root);
		},

		apriFattura(a) {
			this.filters.closePopUp('popUpAssociazioni' + this.rs);
			this.$router.push({ path: '/Invoice', query: { NUMERO: a.NUMERO, ANNO: a.DATA_FATTURA_IT.substr(6, 4), TIPO: this.cfg.tipoFattura } });
		},

		apriIncasso(righe) {
			righe = righe.filter(r => r.INCASSATO != 1);
			if (righe.length == 0) { utils.alert.warning('Nessun incasso ancora da registrare tra quelli selezionati.'); return; }
			if (!this.stessoIntestatario(righe)) return;
			this.incasso = { IDS: righe.map(r => r.ID_INCASSO), IMPORTO: utils.array.sumByField(righe, 'IMPORTO'), INTESTATARIO: righe[0].INTESTATARIO, DATA_MOVIMENTO: new Date(), FK_ID_CONTO: '', DESCRIZIONE: righe.length == 1 ? righe[0].DESCRIZIONE : '' };
			this.filters.openPopUp('popUpIncasso' + this.rs);
		},

		incassa() {
			const params = { IDS: this.incasso.IDS, DATA_MOVIMENTO: this.filters.formatDateOnly(this.incasso.DATA_MOVIMENTO), FK_ID_CONTO: this.incasso.FK_ID_CONTO, DESCRIZIONE: this.incasso.DESCRIZIONE };
			utils.ajax('shared/incassi/incassa', params, (response) => {
				utils.alert.success(response.messaggio);
				this.filters.closePopUp('popUpIncasso' + this.rs);
				this.getRighe();
			}, true, 0, 'POST');
		},

		// L'incasso è un movimento di Prima Nota: annullarlo rimette da incassare tutte le righe che copriva
		annullaIncasso(r) {
			utils.alert.confirm('Annullare l\'incasso del ' + r.DATA_INCASSO_IT + '? Il movimento verrà eliminato dalla Prima Nota.', () => {
				utils.ajax('shared/prima_nota/delete', { ID_MOVIMENTO: r.FK_ID_MOVIMENTO }, (response) => {
					utils.alert.success(response.messaggio);
					this.getRighe();
				}, true, 0, 'DELETE');
			}, this.$root);
		},

		apriEsportazione(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazione' + this.rs);
		},

		esportaDati(formato) {
			utils.esportaTabella({ tipo: this.esportazioneTipo, formato: formato, arrayCompleto: this.filtrate, arrayPagina: this.paginatedList.arr, idField: this.cfg.chiave, modulo: this.modulo });
		},

		togliFiltroOrigine() {
			this.filtroOrigine = null;
			this.$router.replace({ query: {} });
		},

		normalizza(obj, campo) {
			obj[campo] = this.filters.formattaImporto(this.filters.parseImporto(obj[campo]));
		},
	},

	created: function () {
		// Arrivo da un altro modulo (budget, modalità di pagamento) con ?ORIGINE_TIPO=&ORIGINE_ID=: solo le sue righe, su tutti gli anni
		const q = this.$route.query;
		if (q.ORIGINE_TIPO && num(q.ORIGINE_ID)) {
			this.filtroOrigine = { ORIGINE_TIPO: q.ORIGINE_TIPO, ORIGINE_ID: num(q.ORIGINE_ID) };
			this.anno = 0;
		}
		this.getRighe();
	},
}
</script>
